import {
  AccessTime,
  ArrowForward,
  CorporateFare,
  RocketLaunch,
  Star,
  VolunteerActivismOutlined,
} from '@mui/icons-material'
import {
  alpha,
  Button,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'

import useIsPartner from '~/features/partners/hooks/useIsPartner/v2'
import rem from '~/utils/ui'

const DEMO_BENEFITS = [
  {
    label: 'A 30-minute demo — no prep needed',
    icon: AccessTime,
  },
  {
    label: 'Hands-on onboarding — we do the heavy lifting',
    icon: VolunteerActivismOutlined,
  },
  {
    label: 'Built for multi-location operators',
    icon: CorporateFare,
  },
]

function FreePlanCard() {
  const theme = useTheme()
  const isPartner = useIsPartner()

  return (
    <Stack
      component={Paper}
      alignItems="flex-start"
      spacing={2}
      useFlexGap
      sx={{
        padding: rem(24),
        position: 'relative',
        '&.MuiPaper-root': {
          borderRadius: rem(16),
        },
      }}
    >
      <Chip
        icon={<Star />}
        label="Free Plan"
        sx={{
          backgroundColor: alpha(theme.palette.tertiary1, 0.1),
          color: theme.palette.tertiary1,
          textTransform: 'uppercase',
          fontWeight: 700,
          fontSize: rem(12),
          height: rem(28),
          paddingInline: rem(4),
          marginLeft: 'auto',
          position: 'absolute',
          top: rem(16),
          right: rem(16),
          '.MuiChip-icon': {
            color: theme.palette.tertiary1,
            fontSize: rem(16),
          },
        }}
      />
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          backgroundColor: alpha(theme.palette.success.light, 0.2),
          width: rem(56),
          height: rem(56),
          borderRadius: rem(16),
        }}
      >
        <RocketLaunch
          sx={{ color: theme.palette.success.light, fontSize: rem(30) }}
        />
      </Stack>
      <Typography
        variant="h2"
        sx={{
          fontSize: rem(24),
          fontWeight: 700,
          textWrap: 'balance',
          lineHeight: rem(36),
        }}
      >
        Launch your first assistant with our team
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: theme.palette.text.secondary, fontSize: rem(16) }}
      >
        Creating an AI assistant is part of a paid plan. Book a quick demo and
        we&apos;ll match you to the right plan — then help you set it up fast,
        with very little effort on your side.
      </Typography>
      <List
        sx={{
          '&&&': {
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: rem(12),
          },
        }}
      >
        {DEMO_BENEFITS.map(({ label, icon: Icon }) => (
          <ListItem key={label} sx={{ padding: 0, gap: rem(8) }}>
            <ListItemIcon
              sx={{ color: theme.palette.tertiary1, minWidth: 'auto' }}
            >
              <Icon sx={{ fontSize: rem(18) }} />
            </ListItemIcon>
            <ListItemText
              primary={label}
              sx={{
                margin: 0,
                color: theme.palette.text.secondary,
                '.MuiListItemText-primary': {
                  fontSize: rem(14),
                },
              }}
            />
          </ListItem>
        ))}
      </List>
      {!isPartner && (
        <Button
          endIcon={<ArrowForward />}
          onClick={() => {
            window.open('https://replify.ai/demo', '_blank')
          }}
          sx={{ letterSpacing: 0, width: '100%' }}
          variant="primary"
        >
          Book a demo
        </Button>
      )}
    </Stack>
  )
}

export default FreePlanCard
